import { useQuery } from 'react-query';
import {
  getRosterFunctionsByCostCenterAndDate,
  RosterFunctionByCostCenterAndDate
} from 'RestAPIs/roster/functions';

const useGetRosterFunctionsByCostCenterAndDate = ({
  costCenterId,
  startDate,
  endDate
}: RosterFunctionByCostCenterAndDate) => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['rosterFunctions', 'list', costCenterId, startDate, endDate],
    async () => {
      const { data } = await getRosterFunctionsByCostCenterAndDate({
        costCenterId,
        startDate,
        endDate
      });
      return data;
    }
  );
  return { data, isFetching, isError, refetch };
};

export default useGetRosterFunctionsByCostCenterAndDate;
